import { ICurrencyServiceState } from "./model"

export const state: ICurrencyServiceState = {
  cadExchangeRateByCurrencyId: undefined as any
}
